// extracted by mini-css-extract-plugin
export var alignCenter = "_7z-d";
export var bannerShown = "_7z-6";
export var buttonContent = "_7z-0";
export var cardList = "_7z-1";
export var centerContent = "_7z-2";
export var chevron = "_7z-3";
export var closePanelButton = "_7z-k";
export var conversationContextContainer = "_7z-l";
export var conversationDetailContainer = "_7z-4";
export var detailWrapper = "_7z-7";
export var dropdownButton = "_7z-e";
export var dropdownTitle = "_7z-9";
export var fullHeight = "_7z-5";
export var hidden = "_7z-a";
export var icon = "_7z-b";
export var mergeSuggestionWrapper = "_7z-m";
export var panel = "_7z-i";
export var portalButtonsWrapper = "_7z-c";
export var right = "_7z-j";
export var tableSummaryContainer = "_7z-8";
export var tableSummaryHeader = "_7z-g";
export var threeDotsButton = "_7z-f";
export var wide = "_7z-h";